import { SmallProjectCard } from '../common/SmallProjectCard.js';
import { SmallProjectList } from '../common/SmallProjectList.js';
import { addCommas } from '../utils/numberUtils.ts';
import { TrackSectionView } from '../common/TrackSectionView.tsx';


export const MarketingProjectCards = ({projects, numProjects, data}) => {
    const getProjectUrl = () => {
        let path = data.backfillUrl;
        if (path[0] === '/') {
            path = path.slice(1);
        }

        let uri = new Uri(path);
        // Hack: we skip teacher/school search for queries with unexpected query-string-params. That's what we want
        // when linking to "more projects", so we add an otherwise-meaningless projectSearchOnly=true here.
        uri.addQueryParam('projectSearchOnly', 'true');

        return uri.toString();
    };

    const impactHeader = () => {
        if (data.impactState == null) {
            return (<h3>{addCommas(numProjects)} classrooms nationwide are asking for similar supplies:</h3>);
        } else {
            return (<h3>{numProjects} classrooms in {data.impactState} are asking for similar supplies:</h3>);
        }
    }
    return (
        <div className="more-projects">
        <TrackSectionView sectionName={"Project Cards"}>
            {impactHeader()}
            <SmallProjectList projects={projects} />
            <a href={getProjectUrl()}>View all requests</a>
        </TrackSectionView>
        </div>
    )
}
